import {
  DrawerComponent,
  MenuComponent,
  ScrollComponent,
  StickyComponent,
  SwapperComponent,
  ToggleComponent,
} from '@/assets/ts/components';
import { ThemeModeComponent } from '@/assets/ts/layout';
import type { App } from 'vue';
import KTIcon from '@/utils/helpers/icon/KTIcon.vue';

/**
 * @description Initialize KeenThemes custom components
 */
const initializeComponents = (): void => {
  ThemeModeComponent.init();
  setTimeout(() => {
    ToggleComponent.bootstrap();
    StickyComponent.bootstrap();
    MenuComponent.bootstrap();
    ScrollComponent.bootstrap();
    DrawerComponent.bootstrap();
    SwapperComponent.bootstrap();
  }, 0);
};

/**
 * @description Reinitialize KeenThemes custom components
 */
const reinitializeComponents = (): void => {
  ThemeModeComponent.init();
  setTimeout(() => {
    ToggleComponent.reinitialization();
    StickyComponent.reInitialization();
    MenuComponent.reinitialization();
    reinitializeScrollComponent();
    DrawerComponent.reinitialization();
    SwapperComponent.reinitialization();
  }, 0);
};

const reinitializeScrollComponent = (): void => {
  ScrollComponent.reinitialization();
  ScrollComponent.updateAll();
};

/**
 * Initialize KTIcon global component instance
 * @param app vue instance
 */
const initKtIcon = (app: App<Element>): void => {
  app.component('KTIcon', KTIcon);
};

export {
  initializeComponents,
  reinitializeComponents,
  reinitializeScrollComponent,
  initKtIcon,
};
